import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion, useReducedMotion } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';

/** Barra de compra fija en móvil: aparece al pasar el hero y se oculta en el bloque de precio. */
export function StickyMobileCta() {
  const [visible, setVisible] = useState(false);
  const reduceMotion = useReducedMotion();
  useEffect(() => {
    const onScroll = () => {
      const scrollable = document.documentElement.scrollHeight - window.innerHeight;
      const progress = scrollable > 0 ? window.scrollY / scrollable : 0;
      const pricing = document.getElementById('comprar');
      const pricingVisible = pricing ? pricing.getBoundingClientRect().top < window.innerHeight * 0.85 : false;
      setVisible(progress >= 0.65 && !pricingVisible);
    };
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  return <AnimatePresence data-id="element-527" data-mp="1bgmpwucy9he0">
      {visible && <motion.div className="fixed inset-x-0 bottom-0 z-40 border-t border-gold/40 bg-white/95 px-4 py-3 backdrop-blur md:hidden" initial={reduceMotion ? undefined : {
      y: 72,
      opacity: 0
    }} animate={reduceMotion ? undefined : {
      y: 0,
      opacity: 1
    }} exit={reduceMotion ? undefined : {
      y: 72,
      opacity: 0
    }} transition={{
      duration: 0.24,
      ease: [0.23, 1, 0.32, 1]
    }} data-id="element-528" data-mp="1bho9jn817c7c">
          <div className="flex items-center gap-3" data-id="element-529" data-mp="snsjwpxb0zlx">
            <div className="min-w-0" data-id="element-530" data-mp="xgvhra946v7x">
              <p className="text-[0.65rem] font-semibold uppercase tracking-[0.1em] text-muted" data-id="element-531" data-mp="xhwtlgxyflqp">
                Pago único hoy
              </p>
              <p className="flex items-baseline gap-1.5 text-lg font-extrabold leading-tight text-gold" data-id="element-532" data-mp="nq95nq0lwmtz">
                <span className="text-sm font-bold text-faint line-through" data-id="element-533" data-mp="9qr9uqow89b4">$39</span>
                $15,90 <span className="text-xs font-bold" data-id="element-534" data-mp="eqm0qu8o4yw6">USD</span>
              </p>
            </div>
            <a href="#comprar" className="ml-auto inline-flex items-center gap-2 rounded-full bg-forest px-5 py-3 text-sm font-semibold text-white transition-[transform,background-color] duration-200 ease-smooth active:translate-y-0.5 hover:bg-forest-dark" data-id="element-535" data-mp="2gftcxrj51mw7">
              Quiero el protocolo
              <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-536" data-mp="22o4xbe9okgah" />
            </a>
          </div>
        </motion.div>}
    </AnimatePresence>;
}